// Module
var code = "<span ng-bind=\"$parent.row.created_at | date:'MMM d, y (h:mm:ss a)'\"></span>";
// Exports
module.exports = code;